import { org_sector_type_enum } from '@predium/enums';
import { maybeEnum } from '@predium/utils';
import isNil from 'lodash/isNil';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSession } from '@/components/session/useSession';
import { PATHS } from '@/routes';
import { StatusQuoAnalysisTabEnum } from '@/routes/search_params/searchParamsEnums';
import { useStatusQuoSelectionStorage } from '@/sections/StatusQuoAnalysis/useStatusQuoSelectionStorage';

export const RedirectToStatusQuoAnalysisBuilding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { buildingId: storedBuildingId } = useStatusQuoSelectionStorage();
  const session = useSession(false);

  const isBankingOrg =
    maybeEnum(org_sector_type_enum, sessionStorage.getItem('org-sector')) === org_sector_type_enum.BANKING;

  const isOnBuildingsPath = location.pathname.startsWith(PATHS.statusQuoAnalysis.buildings());

  const sessionStatus = session.status;
  const firstBuildingId = session.status === 'authenticated' ? session.firstBuildingId : null;
  const userId = session.status === 'authenticated' ? session.user.id : null;

  useEffect(() => {
    if (sessionStatus !== 'authenticated' || isNil(userId)) return;

    if (isBankingOrg && !isOnBuildingsPath) {
      navigate(PATHS.dataCollection.economicUnits({ economicUnitResponsibleUserIds: [userId] }), {
        replace: true,
      });
      return;
    }

    if (storedBuildingId) {
      navigate(
        PATHS.statusQuoAnalysis.building(
          { id: storedBuildingId },
          {
            // benchmark omitted → no comparison, the default.
            tab: StatusQuoAnalysisTabEnum.DEMAND,
          },
        ),
        { replace: true },
      );
      return;
    }

    if (firstBuildingId) {
      navigate(PATHS.statusQuoAnalysis.building({ id: firstBuildingId }, { tab: StatusQuoAnalysisTabEnum.DEMAND }), {
        replace: true,
      });
      return;
    }

    navigate(PATHS.statusQuoAnalysis.noBuildings(), { replace: true });
  }, [sessionStatus, userId, firstBuildingId, isBankingOrg, isOnBuildingsPath, storedBuildingId, navigate]);

  return null;
};
